import SimpleIntro from "@/components/simpleIntro";
import { INTRO_CONSTANTS } from "./constants";

const IntroComponent = () => {
  return <SimpleIntro {...INTRO_CONSTANTS} />;
};

export default IntroComponent;
